import React from "react";

import Accordion from 'react-bootstrap/Accordion';
import styles from "./Modal_Components.module.css"

const FAQs = () => {
  return (
    <Accordion className="custom-accordion">
      <Accordion.Item eventKey="0">
        <Accordion.Header><span className={styles.accordionHeader}>Terms of Service and Privacy Policy</span></Accordion.Header>
        <Accordion.Body>
          <div>
            <h6>Privacy Policy</h6>
            At MySchedulePal, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your information.
            1. Information We Collect
            - Personal Identifiable Information (PII): Name, email address, phone number, etc.
            - Health Information (if applicable): Data related to scheduling medical appointments.
            - Usage Data: Device information, IP address, and usage patterns.
            2. How We Use the Information
            We use your information to:
            - Provide and improve the Service.
            - Ensure compliance with legal and regulatory standards.
            - Communicate updates or changes to the Service.
            3. Data Sharing
            We do not sell your information. We may share data with:
            - Service providers (e.g., cloud storage, payment processors).
            - Authorized entities as required by law.
            - We have agreements setup to protect Patient PHI, ensuring HIPAA Compliance.
            4. Data Security
            We employ robust security measures, including encryption and secure storage, to protect your data from unauthorized access. We also employ a Business Associate Agreement with our 3rd party api provider, ensuring privacy and HIPAA Compliance.
            5. User Rights
            Users have the right to:
            - Access and review their data.
            - Request corrections or deletions.
            - Opt out of non-essential data processing.
            6. HIPAA Compliance
            For users in the healthcare sector, we comply with HIPAA standards to protect PHI. Please avoid sharing sensitive health data through non-secure channels.
            If you have questions about this Privacy Policy, contact us at support@myschedulepal.com.
            <h6 className='mt-2'>Terms of Service</h6>
            Welcome to MySchedulePal! These Terms of Service ("Terms") govern your use of our services, including our mobile application and website (collectively, the "Service"). By using MySchedulePal, you agree to be bound by these Terms. Please read them carefully.
            1. User Responsibilities
            Users agree not to misuse the Service, including but not limited to:
            - Sharing accounts or login credentials with others.
            - Using the Service for unlawful purposes.
            - Interfering with the normal operation of the Service.
            - Sending, showing or using patient information in a way that would break HIPAA Compliance.
            2. Service Disclaimer
            MySchedulePal is designed to assist with scheduling and time management but is not a replacement for professional medical or healthcare advice. Always consult qualified professionals when making health-related decisions.
            3. Limitation of Liability
            To the maximum extent permitted by law, MySchedulePal is not liable for any damages arising from the use or inability to use the Service, including errors, interruptions, or unauthorized access.
            4. HIPAA Disclaimer
            If the Service handles Protected Health Information (PHI), it complies with HIPAA guidelines. However, users are responsible for not sharing PHI through unprotected channels.
            5. Governing Law
            These Terms are governed by the laws of Your Jurisdiction. Any disputes will be resolved in the courts of Your Jurisdiction.
            6. Termination Clause
            We reserve the right to suspend or terminate accounts for violations of these Terms or any other policies.
            If you have questions about these Terms, contact us at support@myschedulepal.com.
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header><span className={styles.accordionHeader}>What is the core functionality of MySchedulePal?</span></Accordion.Header>
        <Accordion.Body>
          <div>
            <p className="pb-1">Automatically group patients, optimize routes and get drive time between each. You'll be able to focus more on patient care and less on clerical work.</p>
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2">
        <Accordion.Header><span className={styles.accordionHeader}>Can I use MySchedulePal on my phone or tablet?</span></Accordion.Header>
        <Accordion.Body>
        <div>
          <p className="pb-1">
            Absolutely! Download MySchedulePal on Apple! 
          </p>
          <p>
            We are constantly developing new features and pushing updates. Android is coming soon!
          </p>
        </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="3">
        <Accordion.Header><span className={styles.accordionHeader}>Is MySchedulePal HIPAA compliant?</span></Accordion.Header>
        <Accordion.Body>
        <div>
          <p className="pb-1">
            Yes! Jumping through those hoops wasn’t easy, but we made it!
          </p>
          <p>
            In all seriousness, yes, MySchedulePal is HIPAA compliant. We’ve implemented end-to-end encryption and secured all necessary BAAs. Rest assured, we’ve got you covered.
          </p>
        </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="4">
        <Accordion.Header><span className={styles.accordionHeader}>How do I schedule a patient?</span></Accordion.Header>
        <Accordion.Body>
          <div>
            <ol>
              <li>After you've created at least 2 patients, head over to the scheduling tab.</li>
              <li>Click and hold the patient you'd like to schedule.</li>
              <li>Drag the patient's name over to the calendar.</li>
              <li>Release the patients name over the spot where you'd like to schedule them.</li>
            </ol>
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="5">
        <Accordion.Header><span className={styles.accordionHeader}>How do I move the patient from one time to another?</span></Accordion.Header>
        <Accordion.Body>
          <div>
            <ol>
              <li>Click and hold the event you'd like to move on the calendar.</li>
              <li>Drag the event to the desired spot and release.</li>
            </ol>
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="6">
        <Accordion.Header><span className={styles.accordionHeader}>How do I test my schedule?</span></Accordion.Header>
        <Accordion.Body>
          <div>
            After scheduling at least 2 patients, you can test the drive-time viability for the day. Select the desired day in the upper right corner and click "Test Day". <span style={{color: "var(--viable)", fontWeight: "600"}}>Green</span> indicates viable drive times, while <span style={{color: "var(--notViable)", fontWeight: "600"}}>Red</span> means adjustments are needed due to insufficient time. If you need to make adjustments drag your patient to a new spot and test again.
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="7">
        <Accordion.Header><span className={styles.accordionHeader}>What do the colors mean after I've tested?</span></Accordion.Header>
        <Accordion.Body>
          <div>
            <ul>
              <li className="mb-2"><span style={{color: "var(--viable)", fontWeight: "600"}}>Green:</span> This indicates that there is enough time to get from point A to point B, accounting for the allotted buffer time.</li>
              <li><span style={{color: "var(--notViable)", fontWeight: "600"}}>Red:</span> This indicates that you do not have enough time to get from A to B on time. You'll need to adjust by dragging the event into a new slot.</li>
            </ul>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default FAQs;
